import React, { useEffect, useMemo, useState } from 'react'
import { node } from 'prop-types'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getUrlSSO } from 'services/auth'

import { Hub } from 'aws-amplify'
import {
	Authenticator,
	View,
	Image,
	useTheme,
	Button,
} from '@aws-amplify/ui-react'
import LogOutContext from '~/context/LogOutContext'
import { clearSession } from 'states/modules/session'

import '@aws-amplify/ui-react/styles.css'
import styles from './index.module.scss'
import logo from '~/assets/logo.svg'
import SignIn from 'pages/signIn'

const components = {
	Header() {
		const { tokens } = useTheme()

		return (
			<View
				textAlign="center"
				padding={`${tokens.space.large} ${tokens.space.xxl} ${tokens.space.xs} ${tokens.space.xxl}`}>
				<Image alt="Lawing logo" src={logo} />
			</View>
		)
	},
	Footer() {
		const [loading, setLoading] = useState(false)

		return (
			<>
				<span>&nbsp;</span>
				<hr />
				<span>&nbsp;</span>
				<Button
					onClick={async () => {
						setLoading(true)
						const provider = process?.env?.REACT_APP_SSO_PROVIDER || 'allcare'
						let urlSSO = await getUrlSSO(provider)
						if (urlSSO['url_sso']) {
							window.location = urlSSO['url_sso']
						}
					}}
					isFullWidth
					isLoading={loading}
					variation="primary"
					type="button">
					Login SSO
				</Button>
			</>
		)
	},
}

function AuthWrapper({ children }) {
	const [userContracts, setUserContracts] = useState(null)
	const dispatch = useDispatch()
	const history = useHistory()
	const { search } = useLocation()

	const initialState = useMemo(() => {
		const searchParams = new URLSearchParams(search)
		return searchParams.get('signup') === 'true' ? 'signUp' : 'signIn'
	}, [search])

	useEffect(() => {
		setUserContracts(JSON.parse(localStorage.getItem('user-contracts')))
		// if(userContracts){
		// 		dispatch(clearSession())
		// 		history.push('/')
		// }else{
		Hub.listen('auth', (data) => {
			// console.log('Auth data', data)
			if (data.payload.event === 'signIn') {
				// console.log('event signIn')
				dispatch(clearSession())
				history.push('/')
			}
			if (data.payload.event === 'signOut') {
				// console.log('event signOut')
				window.history.pushState({}, '', '/')
			}
		})
		// }
	}, [dispatch, history])

	return userContracts == null ? (
		<Authenticator
			className={
				process.env.REACT_APP_SIGNUP_ON === 'true'
					? ''
					: styles['amplify-nosignup']
			}
			components={components}
			initialState={initialState}
			loginMechanisms={['email']}
			signUpAttributes={['name', 'email']}>
			{({ signOut, user }) => {
				return (
					<LogOutContext.Provider value={signOut}>
						{children}
					</LogOutContext.Provider>
				)
			}}
		</Authenticator>
	) : (
		<>{children}</>
	)
}

AuthWrapper.propTypes = {
	children: node.isRequired,
}

export default AuthWrapper
